import { render, staticRenderFns } from "./TrainingRequest.vue?vue&type=template&id=6481ff88"
import script from "./TrainingRequest.vue?vue&type=script&lang=js"
export * from "./TrainingRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports